import arrayToObject from 'utils/arrayToObject';
import merge from 'utils/merge';
import {
  CREATE_CHAT_FLOW_INTEGRATION_FULFILLED,
  DESTROY_CHAT_FLOW_INTEGRATION_FULFILLED,
  FIND_CHAT_FLOW_INTEGRATION_FULFILLED,
  FIND_CHAT_FLOW_INTEGRATION_PENDING,
  LOAD_CHAT_FLOW_INTEGRATIONS_FULFILLED,
  LOAD_CHAT_FLOW_INTEGRATIONS_PENDING,
  UPDATE_CHAT_FLOW_INTEGRATION_FULFILLED,
  TEST_CHAT_FLOW_INTEGRATION_CONNECTION_FULFILLED,
} from './action';

const chatFlowIntegrationsReducer = (
  state = { chatFlowIntegrations: {}, loading: false, loaded: false },
  { type, payload, meta },
) => {
  switch (type) {
    case LOAD_CHAT_FLOW_INTEGRATIONS_FULFILLED: {
      const chatFlowIntegrations = payload.chatFlowIntegrations.map(c =>
        merge(state.chatFlowIntegrations[c._id], c),
      );

      return merge(state, {
        chatFlowIntegrations: arrayToObject(chatFlowIntegrations),
        loading: false,
        loaded: true,
      });
    }

    case FIND_CHAT_FLOW_INTEGRATION_PENDING: {
      return merge(state, { loading: true });
    }

    case CREATE_CHAT_FLOW_INTEGRATION_FULFILLED:
    case FIND_CHAT_FLOW_INTEGRATION_FULFILLED:
    case UPDATE_CHAT_FLOW_INTEGRATION_FULFILLED:
    case TEST_CHAT_FLOW_INTEGRATION_CONNECTION_FULFILLED: {
      const chatFlowIntegration = merge({ ...state.chatFlowIntegrations[payload._id] }, payload);
      return merge(state, {
        loading: false,
        chatFlowIntegrations: { ...state.chatFlowIntegrations, [payload._id]: chatFlowIntegration },
      });
    }

    case DESTROY_CHAT_FLOW_INTEGRATION_FULFILLED: {
      const chatFlowIntegrations = { ...state.chatFlowIntegrations };
      delete chatFlowIntegrations[meta.IntegrationId];
      return merge(state, { chatFlowIntegrations });
    }

    case LOAD_CHAT_FLOW_INTEGRATIONS_PENDING:
      return merge(state, { loading: true, loaded: false });

    default:
      return state;
  }
};

export default chatFlowIntegrationsReducer;
